export default `
  :root {
      /* # Color Palette */
      --wuk-primary-color-900: #4B3A69;
      --wuk-primary-color-800: #5C4389;
      --wuk-primary-color-700: #6D49AB;
      --wuk-primary-color-600: #7E5BB9;
      --wuk-primary-color-500: #9979D3;
      --wuk-primary-color-400: #B49CDE;
      --wuk-primary-color-300: #CBBAE8;
      --wuk-primary-color-200: #DCD1F0;
      --wuk-primary-color-100: #E8E0F5;
      --wuk-primary-color-50:  #F3F0FA;

      --wuk-secondary-color-900: #7A341F;
      --wuk-secondary-color-800: #A34529;
      --wuk-secondary-color-700: #D95026;
      --wuk-secondary-color-600: #EB6D47;
      --wuk-secondary-color-500: #FF8966;
      --wuk-secondary-color-400: #F8A58C;
      --wuk-secondary-color-300: #FAC3B2;
      --wuk-secondary-color-200: #FBD2C5;
      --wuk-secondary-color-100: #FDE1D9;
      --wuk-secondary-color-50:  #FEF0EC;

      --wuk-neutral-color-20: #F7F4F2;

      /* # Buttons */
      --wuk-toggle-input-active-text-color: white;
      --wuk-button-theme-text-hover-color: white;

      --wuk-button-theme-text-color: var(--wuk-context-color-2);
      --wuk-button-theme-text-disabled-color: var(--wuk-context-color-5);
      --wuk-button-theme-text-hover-color: var(--wuk-primary-color-dark);

     /* # Input Range */
      --wuk-range-thumb-color-wuk: var(--wuk-neutral-color-20);
  }
`;
